import React from "react";
import { useRoiStockContext } from "../../../context/roi/stock/RoiStockContext";
import Grid2 from "@mui/material/Unstable_Grid2";
import Table from "../../../components/table/Table";
import { faCols_roiStock } from "../../../components/tableHeaderNames/HeaderName";

const RoiStock = () => {
  const { tableData, highlightedCols } = useRoiStockContext();

  const percentCols = [
      "daily_roi",
      "weekly_roi",
      "monthly_roi",
      "quarterly_roi",
      "half_yearly_roi",
      "yearly_roi",
      "three_years_roi",
  ]

  return (
    <Grid2 container spacing={2}>
      <Grid2 xs={12}>
        <Table
          tableData={tableData}
          tableTitle={{
            title: "بازدهی به تفکیک سهام",
            desc: "متن نمایشی",
          }}
          height={"88vh"}
          faCols={faCols_roiStock}
          percentCols={percentCols}
          highlightedCols={highlightedCols}
        />
      </Grid2>
    </Grid2>
  );
};

export default RoiStock;
